import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { errorHandling } from "../../helper";

const cartSlice = createSlice({
  name: "auth",
  initialState: {
    loading: false,
    cartList: [],
    cartDetails: {},
  },
  reducers: {
    loading: (state, action) => {
      state.loading = action.payload;
    },
    cartList: (state, action) => {
      state.cartList = action.payload;
    },
    getCartDetailsFunc: (state, action) => {
      state.cartDetails = action.payload;
    },
  },
});

export const { cartList, loading, getCartDetailsFunc } = cartSlice.actions;

export const getCartList = (navigate) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_all_add_to_cart`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(cartList(data?.trips));
    dispatch(loading(false));
    // navigate("/");
  } catch (error) {
    toast.error(error?.response?.data?.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const getCartDetails = (id, navigate) => async (dispatch) => {
  try {
    // dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_add_to_cart_data/${id}`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });

    dispatch(getCartDetailsFunc(data?.trip));
    // dispatch(loading(false));
  } catch (error) {
    toast.error(error?.response?.data?.error);
    // dispatch(loading(false));
    errorHandling(error);
  }
};

export default cartSlice.reducer;
